<template>
    <div>
        <div id="mainhold">
            <div id="leftcolumn" class="cols">DIRECT SALE INVOICE<br>
            <input type="text" class="instyle" placeholder="ArtmarketID" v-model="amid">
            <input type="text" class="instyle" placeholder="Username" v-model="username">
            <div class="btn bgTeal cpointer" @click="prepInv">SETUP</div>
            </div>
            <div id="rightcolumn" class="cols" v-if="displaying">
            <div class="imgHolder" :style="{ 'background-image': `url(${itemDoc.mainURL})`}"></div>
            <div class="">Sales Invoice for {{buyerDoc.fullname}}</div>
            <div class="wrapper">
                <select class="instyle" v-model="ampurchase">
                    <option value="null" disabled>Am Purchase?</option>
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
                <select class="instyle" v-model="needShip">
                    <option value="null" disabled>Need Shipping?</option>
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>       
                <div class="amTealregular">SALES TAX</div><input type="text" class="instyle" v-model="salesTax">
                <div class="amTealregular">SHIP COST</div><input type="text" class="instyle" v-model="shipCost">
                <div class="amTealregular">DISCOUNT</div><input type="text" class="instyle" v-model="discount">
                <textarea class="textview" v-model="message"></textarea>
                <div class="btn bgTeal cpointer" @click="sendInv">SEND</div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions'
import 'firebase/firestore'
import db from '../main'
export default {
    name: "invoice",
    data(){
        return {
            userID: "",
            doc: {},
            amid: "",
            wglove: false,
            shipped: false,
            ampurchase: false,
            salesTax: 0,
            shipCost: 0,
            itemPrice: 0,
            museoDisc: 0,
            invoiceTotal: "",
            mainIMG: "",
            buyerID: "",
            username:"",
            displaying: false,
            buyerDoc: {},
            itemDoc: {},
            needShip: false,
            discount: 0,
            message: "",
                    }
    },
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if (user){
                this.userID = firebase.auth().currentUser.uid
            }
        })
        
    },
    methods: {
        sendInv(){
            const total = (parseFloat(this.salesTax) + parseFloat(this.shipCost) + parseFloat(this.itemDoc.price)) - parseFloat(this.discount)
            const data = ({
                buyerID: this.buyerDoc.user_Id,
                salesTax: parseFloat(this.salesTax),
                shipCost: parseFloat(this.shipCost),
                needShip: this.needShip,
                total: parseFloat(total.toFixed(2)),
                artmarketID: this.amid,
                itemPrice: parseFloat(this.itemDoc.price),
                discount: parseFloat(this.discount),
                message: this.message,
                artmarketPurchase: this.ampurchase
            })
            console.log(data)
            const makeInvoice = firebase.functions().httpsCallable('makeInvoice')
            return makeInvoice(data).then(result => {
                if(result){
                    console.log(result)
                    this.message = ""
                    this.salesTax = 0
                    this.shipCost = 0
                    this.artmarketID = ""
                    this.username = ""
                    alert("Made Invoice")
                }
            }).catch(err => {
                if(err){
                    console.log('error occurred', err)
                    alert('An error occurred')
                }
            })
        },
        prepInv(){
            this.displaying = false;
            this.itemDoc = {}
            this.buyerDoc = {}

            const username = this.username;
            const amID = this.amid

            console.log(username, amID)
            db.collection("users").where('username', '==', username).get().then(doc => {
                if(doc){
                    doc.forEach(d => {
                        const data = d.data();
                        this.buyerDoc = data
                    })
                }
            })

            db.collection('market').doc(amID).get().then(doc => {
                if(doc){
                    const data = doc.data()
                    this.itemDoc = data
                    console.log(data)
                    this.displaying = true
                }
            })
        }
    }
}
</script>


<style scoped>

.mainwrap {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    text-align: left;
}

.spacer {
    width: 100%;
    height: 20px;
    float: left;
    clear: right;
}
    #mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    position: relative;
}

.cpointer {
    cursor: pointer;
}

.btn {
    width: auto;
    height: auto;
    padding: 2%;
    border-radius: 2vmin;
    text-align: center;
    color: white;
    float:right;
    clear: right;
}

#rightcol {
    width: auto;
    height: auto;
    position: fixed;
    top: 0;
    margin-top: 300px;
    right: 0;
    margin-left: 50vw;
}

.imgHolder {
    width: 50px;
    height: 50px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.imgHolder2 {
    width: 250px;
    height: 250px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.wrapper {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: right;
    margin-left: 20px;
}

.instyle {
    width: 100%;
    height: 50px;
    border-style: solid;
    background-color: azure;
    padding: 1%;
    float: left;
    clear: right;
    margin-bottom: 5px;
}

.wrapperr {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: left;
    margin-left: 20px;
}

.listingholder {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    padding: 2%;
    margin-bottom: 5px;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
    overflow: scroll;
}

.textview {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-color:gray;
    border-style: solid;
    border-width: 2px;
    margin-bottom: 10px;
}
</style>